/**
 * @file PastEventsItem 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect} from 'react';
import {Divider} from 'antd';

import './index.less';

function Item({title, time}) {

    return (
        <div className="past-item-container">
            <div className="past-item-content">
                {title}
            </div>

            <div className="past-item-time">
                {time}
            </div>
        </div>
    );
}

export default Item;
